import React from "react";

import classNames from "classnames";
import { Icon, Icomoon } from "../Icon/Icon";

import "./LabelIcon.scss";

export interface LabelIconProps {
  icomoon: Icomoon;
  labelText: string | (JSX.Element | string)[];
  iconColor?: string;
  labelTextColor?: "accent" | "light" | "dark" | "mid";
  containerClassNames?: string[];
  textSize?: "label" | "regular";
}

/**
 * An icon with a label.
 * Currently, only selected Icomoon icons are supported.
 *
 * @status stable
 */
export class LabelIcon extends React.Component<LabelIconProps> {
  public static defaultProps = {
    textSize: "label",
    labelTextColor: "mid",
    iconColor: "accent",
  };

  public render() {
    const { icomoon, containerClassNames, labelText, iconColor, labelTextColor, textSize } = this.props;

    return (
      <div className={classNames("label-icon", `label-text-${textSize}`, containerClassNames)}>
        <Icon icomoon={icomoon} className={`kathmandu-icon text--${iconColor}`} />
        <div className={`text--${textSize} text--${labelTextColor}`}>
          {labelText}
        </div>
      </div>
    );
  }
}
